import React, { useEffect, useState } from 'react';
import { ArrowLeft, Search, X, Sparkles } from 'lucide-react';
import { InventoryCard } from '../components/InventoryCard';
import { useInventory, InventoryItem } from '../hooks/useInventory';
interface SearchItemsProps {
  onBack: () => void;
  onItemClick: (item: InventoryItem) => void;
}
export function SearchItems({
  onBack,
  onItemClick
}: SearchItemsProps) {
  const {
    searchItems,
    inventory
  } = useInventory();
  const [query, setQuery] = useState('');
  const [results, setResults] = useState<InventoryItem[]>([]);
  useEffect(() => {
    if (query.trim() === '') {
      setResults(inventory);
    } else {
      setResults(searchItems(query));
    }
  }, [query, inventory]);
  return <div className="pb-24 max-w-md mx-auto p-4 min-h-screen" data-id="element-498">
      <div className="flex items-center mb-6 gap-3" data-id="element-499">
        <button onClick={onBack} className="p-2 hover:bg-[#C9A227]/20 rounded-full transition-colors" data-id="element-500">
          <ArrowLeft className="w-5 h-5 text-[#722F37]" data-id="element-501" />
        </button>
        <div className="flex-1 relative group" data-id="element-502">
          <input type="text" value={query} onChange={e => setQuery(e.target.value)} placeholder="Accio item..." className="w-full pl-10 pr-10 py-3 rounded-xl border-2 border-[#C9A227]/40 bg-[#FFFDF5] focus:border-[#C9A227] focus:ring-2 focus:ring-[#C9A227]/20 outline-none text-[#2C2C2C] placeholder:text-[#2C2C2C]/40 font-serif transition-all" autoFocus data-id="element-503" />
          <Search className="absolute left-3 top-1/2 -translate-y-1/2 w-5 h-5 text-[#C9A227]" data-id="element-504" />
          {query && <button onClick={() => setQuery('')} className="absolute right-3 top-1/2 -translate-y-1/2 text-[#722F37] hover:text-[#8B0000]" data-id="element-505">
              <X className="w-4 h-4" data-id="element-506" />
            </button>}
          {/* Magical glow on focus */}
          <div className="absolute inset-0 rounded-xl bg-[#C9A227] opacity-0 group-focus-within:opacity-10 transition-opacity pointer-events-none blur-md -z-10" data-id="element-507" />
        </div>
      </div>

      <div className="space-y-3" data-id="element-508">
        <div className="flex items-center justify-between mb-2 px-1" data-id="element-509">
          <p className="text-xs font-bold uppercase tracking-widest text-[#722F37]" data-id="element-510">
            {query ? 'Summoned Items' : 'All Inventory'}
          </p>
          <span className="text-xs text-[#555] font-serif italic" data-id="element-511">
            {results.length} revealed
          </span>
        </div>

        {results.length === 0 ? <div className="text-center py-16 text-[#2C2C2C]/40" data-id="element-512">
            <Sparkles className="w-12 h-12 mx-auto mb-4 text-[#C9A227]/40" data-id="element-513" />
            <p className="text-lg font-cinzel" data-id="element-514">Nothing summoned</p>
            <p className="text-sm font-serif italic mt-1" data-id="element-515">
              Try a different incantation
            </p>
          </div> : results.map(item => <InventoryCard key={item.id} item={item} onClick={() => onItemClick(item)} data-id="element-516" />)}
      </div>
    </div>;
}